/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IAppState } from '../../../core/store/state';
import { getIsSidePanelOpen, getShowReplay } from '../../../core/store/selectors';
import { WindowResizeService } from '../../../core/services';
import { MapAnimations } from '../../animations';

@Component({
  selector: 'fm-map-container',
  templateUrl: './map-container.component.html',
  styleUrls: ['./map-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [MapAnimations.overlaySidePanelOpen]
})
export class MapContainerComponent implements OnInit {
  isReplayOpen$: Observable<boolean>;
  isMobileOrTablet$: Observable<boolean>;
  isSidePanelOpen$: Observable<boolean>;

  ngOnInit(): void {
    this.isReplayOpen$ = this._store.pipe(select(getShowReplay));
    this.isMobileOrTablet$ = this._windowResizeService.isMobileOrTablet$;
    this.isSidePanelOpen$ = this._store.pipe(select(getIsSidePanelOpen));
  }

  constructor(private readonly _store: Store<IAppState>, private readonly _windowResizeService: WindowResizeService) {}
}
